import type { NuasApp, Result } from '@eliboo/api-models';
import type { Observable} from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DA_SERVICE_TOKEN } from '@delon/auth';
import { CacheService } from '@delon/cache';
import { getEnv } from '@env';
import { catchError, concat, first, map, of } from 'rxjs';

import { BridgeService } from './bridge.service';
export type loginType = {
  account?: string;
  code?: string;
  grant_type: 'afspassword' | 'password' | 'sms_code';
  mobile?: string;
  password?: string;
  scene?: string;
  sessionId?: string;
  sig?: string;
  token?: string;
  username?: string;
};
const baseUrl = '/nuas-app-boot/app-api/v1/nuasMemberUserBaseInfo';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  http = inject(HttpClient);
  env = getEnv();
  tokenService = inject(DA_SERVICE_TOKEN);
  cacheService = inject(CacheService);
  bridgeService = inject(BridgeService);
  getUserInfo() {
    return this.http.get<Result<NuasApp.NuasMemberUserAccountAndBaseInfoDTO>>(`${baseUrl}/getUserInfo`);
  }

  getUserInfoByCache() {
    return of(this.cacheService.getNone('user'));
  }

  getUserInfoByFlutter() {
    const userInfo = this.bridgeService.getSysInfo('user');
      // console.log('getUserInfo', userInfo);
      // this.cacheService.set('user', userInfo);
      // this.user.set(userInfo)
    return of(userInfo);
  }


  /**
   * 按顺序获取用户信息
   * @param useFlutter 是否从Flutter获取，默认true
   * @returns Observable<any> 用户信息，任意一个来源成功即返回，后续请求不再执行
   */
  getUserInfoSequentially(useFlutter = true): Observable<NuasApp.NuasMemberUserAccountAndBaseInfoDTO | null> {
    const sources: Observable<NuasApp.NuasMemberUserAccountAndBaseInfoDTO | null>[] = [];
    // 1. 从Flutter获取
    if (useFlutter) {
      sources.push(
        this.getUserInfoByFlutter().pipe(
          map(user => user || null),
          catchError(() => of(null))
        )
      );
    }
    // 1. 从缓存获取
    // if (useCache) {
    //   sources.push(
    //     this.getUserInfoByCache().pipe(
    //       map(user => user || null),
    //       catchError(() => of(null))
    //     )
    //   );
    // }
    // 2. 总是从网络获取
    sources.push(
      this.getUserInfo().pipe(
        map(res => res.data || null),
        catchError(() => of(null))
      )
    );

    return concat(...sources).pipe(
      first(user => user !== null, null) // 获取第一个非空结果
    );
  }

}
